import axios from 'axios';
import { CONFIG } from "../config";


const API_BASE = `${CONFIG.API_URL}/api`;
axios.defaults.withCredentials = true;

function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
      cookie = cookie.trim();
      if (cookie.startsWith(name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

const api = axios.create({
    baseURL: API_BASE,
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });

// Inject CSRF token dynamically on each request
api.interceptors.request.use(
    (config) => {
      const token = getCookie('csrftoken');
      if (token) {
        config.headers['X-CSRFToken'] = token;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );


// Get user data
export async function getUser() {
    const res = await api.get(`/me/`);
    return res.data;
  }

// Create a new order with product info
export async function createOrder(orderData) {
  const response = await api.post("/place/order/", orderData, {
    headers: {
      "X-CSRFToken": getCSRFToken(),
      "Content-Type": "application/json",
    },
  });
  return response.data;
}


function getCSRFToken() {
  const name = 'csrftoken';
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    const [key, value] = cookie.trim().split('=');
    if (key === name) {
      return decodeURIComponent(value);
    }
  }
  return '';
}